import { useEffect } from "react";
import { Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
import NavTabs from "../../ui/NavTabs";
import { financeTabs } from "../../../config/navItemsProjectsDetailsV2";
import useVisibleTabs from "../../../auth/useVisibleTabs";
import useRoleCheck from "../../../auth/useRoleCheck";
import useClanicaCheck from "../../../auth/useClanicaCheck";
import { MODULES } from "../../../auth/roles";
import { useProjectDetailsContext } from "../../../context/ProjectDetailsContext";
import { useGetProjectSplosnoDetails } from "../../../services/ProjectDetails/splosnoAPI";

const Finance = () => {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const { project } = useProjectDetailsContext();
  const { isEditor, isFakultetniSkrbnik } = useRoleCheck(MODULES.PROJEKTI);
  const { data: splosnoDetails } = useGetProjectSplosnoDetails(id);

  const { isUserClanicaInList } = useClanicaCheck(null, project?.clanice ?? []);
  const hasDeminimisEnabled = splosnoDetails?.deminimis === true;

  // Fakultetni skrbnik can view all tabs in finances only if their clanica is on this project
  const canViewClanicaTabs =
    isEditor || (isFakultetniSkrbnik && isUserClanicaInList);

  useEffect(() => {
    const isDeminimisPath = location.pathname
      .toLowerCase()
      .includes("/finance/deminimis");

    if (!isDeminimisPath) return;

    if (!canViewClanicaTabs || !hasDeminimisEnabled) {
      navigate(
        `/Projekti/Podrobnostiv2/${id}/finance/nacrtovana-vrednost-projekta`,
        { replace: true },
      );
    }
  }, [
    location.pathname,
    canViewClanicaTabs,
    hasDeminimisEnabled,
    navigate,
    id,
  ]);

  // Map through financeTabs and set conditional visibility for restricted tabs.
  const tabs = financeTabs.map((tab) => {
    if (tab.key === "stroskovna-mesta") {
      return { ...tab, visible: canViewClanicaTabs };
    }

    if (tab.key === "deminimis") {
      return { ...tab, visible: canViewClanicaTabs && hasDeminimisEnabled };
    }

    return tab;
  });

  const visibleTabs = useVisibleTabs(tabs, MODULES.PROJEKTI);

  return (
    <div>
      <div className=" mb-4">
        <NavTabs listOfTabs={visibleTabs} />
      </div>
      <div className="mt-4">
        <Outlet />
      </div>
    </div>
  );
};

export default Finance;
